import { Icon, IconProps } from '@chakra-ui/react';

export const AddIcon = (props: IconProps) => (
  <Icon width='24px' height='24px' viewBox='0 0 24 24' fill='none' {...props}>
    <g clipPath='url(#clip0_838_12568)'>
      <path
        d='M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z'
        fill='inherit'
      />
    </g>
    <defs>
      <clipPath id='clip0_838_12568'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </Icon>
);
